<template>
  <router-view/>
</template>

<script>
import "@/dist/output.css";

export default {};
</script>
